import { IInputProps } from 'native-base';
import { Input as NativeInput } from 'native-base';
import React from 'react';

export function Input(props: IInputProps) {
  return <NativeInput {...props} />;
}
